import './gifts-landing.scss';
import Form from './ts/form';

const TIME = new Date().getTime();
const modal = document.querySelectorAll('.modal');
const alert = document.querySelector('.alert');
const contactModal = document.querySelector("#contactModal");
const contactModal_advertID = contactModal.querySelector('[name="advert_number[]"]');
const cardv2 = document.querySelectorAll('.cardv2');

modal.forEach(item => {
    // handle closing
    const close = item.querySelector('.modal-close');
    close.addEventListener('click', () => {
        item.classList.remove('open');
    })
});

cardv2.forEach(card => {
    const giftButton = card.querySelector('.button');
    giftButton.addEventListener('click', () => {
        // @ts-ignore
        contactModal_advertID.value = card.getAttribute('advertID');
        contactModal.classList.add('open');
    });
});


setTimeout(() => {
    alert.classList.remove('open');
}, 4000);

new Form(contactModal.querySelector('form'));